<template>
    <div class="mob-map-controls">
        <span :class="{'active' : active == 'map' }" data-target="map" id="mob-map-trigger" @click="showMap()">
            <svg class="location-pin"><use xlink:href="#location-pin"></use></svg>
            Map
        </span>
        <span :class="{'active' : active == 'list' }" data-target="list" id="mob-list-trigger" @click="showList()">
            <svg class="list-icon"><use xlink:href="#list-icon"></use></svg>
            List
        </span>
    </div>
</template>
<script>

export default {


    data(){
        return {
            active : 'list',
        }
    },

    mounted() {
        window.addEventListener('resize', event => {
            if (window.viewport().width > 800) {
                this.enableScroll()
            }
        }, true)
    },

    methods: {

        showMap(){
            $('.map-main').addClass('show')
            this.active = 'map'
            this.disableScroll()
        },

        showList() {
            $('.map-main').removeClass('show')
            this.active = 'list'
            this.enableScroll()
        },

        disableScroll() {
            document.body.style.overflowY = "hidden";
            // window.onscroll = function (event) {
            //     event.preventDefault()
            //     console.log('scrolling')
            //     window.scrollTo(0, 0);
            // };
            // document.body.addEventListener('touchmove', event => {
            //     event.preventDefault();
            // }, false);
        },

        enableScroll() {
            document.body.style.overflowY = "";
            // window.onscroll = function () {
            // };
            // document.body.removeEventListener('touchmove', event => {
            //     event.preventDefault();
            // });
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize')
    },
}
</script>
